
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class CustomerTenantRequestModel extends Model<CustomerTenantRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'companyId', type: 'string' },
		{ name: 'id', type: 'number', isHidden: true },
		{ name: 'name', type: 'string' },
		{ name: 'domain', type: 'string' },
		{ name: 'firstname', type: 'string' },
		{ name: 'lastname', type: 'string' },
		{ name: 'address', type: 'string' },
		{ name: 'city', type: 'string' },
		{ name: 'postalCode', type: 'string' },
		{ name: 'countryCode', type: 'string' },
		{ name: 'contactFirstname', type: 'string' },
		{ name: 'contactLastname', type: 'string' },
		{ name: 'contactPhoneNumber', type: 'string' },
		{ name: 'contactEmail', type: 'string' }
	];
	[key: string]: any;
	
	public companyId?: string;
	public id: number;
	public name: string;
	public domain: string;
	public firstname: string;
	public lastname: string;
	public address: string;
	public city: string;
	public postalCode: string;
	public countryCode: string;
	public contactFirstname: string;
	public contactLastname: string;
	public contactPhoneNumber: string;
	public contactEmail: string;
    
	constructor(){
		super();
		this.companyId = undefined;
		this.id = 0;
		this.name = '';
		this.domain = '';
		this.firstname = '';
		this.lastname = '';
		this.address = '';
		this.city = '';
		this.postalCode = '';
		this.countryCode = '';
		this.contactFirstname = '';
		this.contactLastname = '';
		this.contactPhoneNumber = '';
		this.contactEmail = '';
		
	}
	getProperties(){
		return CustomerTenantRequestModel.classProperties;
	}
}

